function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, watch, computed } from "vue";
import AuthorizePayment from "../authorize-dialog/authorize-payment.vue";
import { grantUpdateCredit } from "@/api/grant/grant";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        authorizeInfo: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    components: {
        AuthorizePayment: AuthorizePayment
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var formRef = ref();
        var loading = ref(false);
        var formValue = ref({
            is_all_support_credit: true,
            image: "",
            // 信用支付
            credit: {
                min_amount: 0,
                approval_url: ""
            }
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var rules = computed(function() {
            return {
                image: !formValue.value.is_all_support_credit ? [
                    {
                        required: true,
                        trigger: "blur",
                        message: "\u8BF7\u4E0A\u4F20\u7279\u6279\u90AE\u4EF6\u622A\u56FE"
                    }, 
                ] : {
                    required: false
                }
            };
        });
        var handleClose = function() {
            emit("update:visible", false);
            loading.value = false;
        };
        var handleSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, result;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate();
                        case 3:
                            result = _ctx.sent;
                            if (result) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            _ctx.prev = 6;
                            loading.value = true;
                            _ctx.next = 10;
                            return grantUpdateCredit({
                                support_credit: 1,
                                adv_id: props.authorizeInfo.adv_id,
                                min_amount: formValue.value.is_all_support_credit ? 0 : formValue.value.credit.min_amount,
                                approval_url: formValue.value.is_all_support_credit ? "" : formValue.value.credit.approval_url
                            });
                        case 10:
                            emit("save-success");
                            handleClose();
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](6);
                            handleClose();
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        6,
                        14
                    ]
                ]);
            }));
            return function handleSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                formValue.value.image = props.authorizeInfo.credit.approval_url || "";
                formValue.value.credit.min_amount = props.authorizeInfo.credit.min_amount || 0;
                if (formValue.value.credit.min_amount) {
                    formValue.value.is_all_support_credit = false;
                }
            }
        }, {
            immediate: true
        });
        return {
            formRef: formRef,
            loading: loading,
            rules: rules,
            formValue: formValue,
            dialogVisible: dialogVisible,
            handleSubmit: handleSubmit,
            handleClose: handleClose
        };
    }
});
